 
import { gql } from "@apollo/client"
 
export const GET_DAILY_ACTIVITY = gql`
  query DailyActivity(
    $userId: String
    $deviceId: String
    $from: String
    $to: String
  ) {
    dailyActivitySummaries(
      userId: $userId
      deviceId: $deviceId
      from: $from
      to: $to
    ) {
      date
      totalActive
      totalIdle
      focusSwitches
      breakCount
      productive
      unproductive
      apps {
        name
        duration
      }
    }
  }
`;
 
export const ACTIVITY_SUMMARY_BY_ID = gql`
  query ActivitySummaryById(
      $userId: String
      $deviceId: String
      $from: String
      $to: String
    ) {
    activitySummaryById(
        userId: $userId
        deviceId: $deviceId
        from: $from
        to: $to
      ) {
      message
      code
      response {
        userId
        totalActive
        totalIdle
        focusSwitches
        breakCount
 
        productive
        unproductive
        avgTaskDuration
 
        apps {
          name
          duration
        }
 
        browser {
          appName
          domain
          duration
        }
 
        domainGroups {
          Work
          Tools
          Other
        }
      }
    }
  }
`;
 
export const GET_DEVICES = gql`
  query GetDeviceData {
    getDeviceData {
      message
      code
      response {
        userId
        deviceId
        lastSeen
      }
    }
  }
`;
 
export const GET_ACTIVITY_APP_NAMES = gql`
  query GetActivityAppNames(
    $userId: String
    $deviceId: String
    $from: String
    $to: String
  ) {
    getActivityAppNames(
      userId: $userId
      deviceId: $deviceId
      from: $from
      to: $to
    )
  }
`;
 
 
export const ACTIVITY_TIMELINE_BY_FILTER = gql`
  query ActivityTimelineByFilter(
    $userId: String
    $deviceId: String
    $from: String
    $to: String
    $appName: String
    $fromTime: String
    $toTime: String
  ) {
    activityTimelineByFilter(
      userId: $userId
      deviceId: $deviceId
      from: $from
      to: $to
      appName: $appName
      fromTime: $fromTime
      toTime: $toTime
    ) {
      type
      appName
      windowTitle
      startTime
      endTime
      duration
    }
  }
`;
 
export const GET_LATEST_USER_SYNC_TIME = gql`
  query GetLatestUserSyncTime {
    getLatestUserSyncTime {
      userId
      timeStamp
    }
  }
`;

 
export const GET_LATEST_DEVICE_SYNC_TIME = gql`
  query GetLatestDeviceSyncTime {
    getLatestDeviceSyncTime {
      deviceId
      timeStamp
    }
  }
`;
 